import React, { memo } from "react";
import { Handle, Position, NodeResizer } from "@xyflow/react";

const TCNode = ({ data, selected }: any) => {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: data.width || "100px",
        height: data.height || "50px",
        background: "transparent", // Remove o fundo branco
        padding: 0, // Remove o padding
        border: "none", // Remove a borda
      }}
    >
      {/* NodeResizer para tornar o nó redimensionável */}
      <NodeResizer
        color="#0077ff"
        isVisible={selected}
        minWidth={50}
        minHeight={25}
        keepAspectRatio={true}
        onResize={(event, size) => {
          data.width = `${size.width}px`;
          data.height = `${size.height}px`;
        }}
      />

      {/* Handles para conexões */}
      <Handle type="source" position={Position.Left} isConnectable id="left" />
      <Handle type="target" position={Position.Left} isConnectable id="left" />
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />
      <Handle
        type="target"
        position={Position.Bottom}
        isConnectable
        id="bottom"
      />
      <Handle type="source" position={Position.Top} isConnectable id="top" />
      <Handle type="target" position={Position.Top} isConnectable id="top" />
      <Handle
        type="source"
        position={Position.Right}
        isConnectable
        id="right"
      />
      <Handle
        type="target"
        position={Position.Right}
        isConnectable
        id="right"
      />

      {/* SVG para o nó */}
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 50"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid meet"
        style={{
          display: "block",
          pointerEvents: "none", // Evita interação com o SVG diretamente
        }}
      >
        <circle cx="50" cy="25" r="20" fill="#7d7d7d" opacity="0.8" />
      </svg>
    </div>
  );
};

export default memo(TCNode);
